export const USERNAME_CHANGE = 'USERNAME_CHANGE';

export const usernameChange = username => ({
  ...username,
  editing: 'username',
  type: USERNAME_CHANGE,
});

export default {
  usernameChange,
};
